module.exports = __webpack_public_path__ + "static/img/home-quality.d631451c.png";